import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Lien entre les déclencheurs placés dans les navbars et app-bug-report, monté à la racine.
 *
 * Le bouton vit dans la barre du haut pour ne recouvrir aucun contenu ; la sélection, la capture
 * et la popup restent à la racine, présentes sur toutes les pages quel que soit le thème.
 */
@Injectable({ providedIn: 'root' })
export class BugReportLauncher {
  /** Vrai pendant la sélection de l'élément : les déclencheurs s'affichent enfoncés. */
  readonly picking = signal(false);

  private readonly toggles = new Subject<void>();

  /** Demandes de démarrage ou d'annulation de la sélection, traitées par app-bug-report. */
  readonly toggleRequests: Observable<void> = this.toggles.asObservable();

  toggle(): void {
    this.toggles.next();
  }
}

/**
 * Attribut posé sur chaque déclencheur : pendant la sélection, un clic dessus doit annuler et
 * non désigner le bouton lui-même comme élément fautif.
 */
export const BUG_REPORT_TRIGGER_ATTRIBUTE = 'data-bug-report-trigger';
